import { Capacitor } from '@capacitor/core';

// Production backend URL
const PROD_API_URL = 'https://mm-backend-t6bw.onrender.com';

// Check if running on a local development machine
const isLocal = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.startsWith('192.168.') ||
    window.location.hostname.startsWith('10.') ||
    window.location.hostname.endsWith('.local')
);

// Check if REACT_APP_API_URL is set to localhost
const rawApiUrl = process.env.REACT_APP_API_URL;
const isRawApiUrlLocal = Boolean(
    rawApiUrl && (rawApiUrl.includes('localhost') || rawApiUrl.includes('127.0.0.1'))
);

// In local mode, default to localhost:5000; in production or mobile, always use production backend (never localhost)
const API_BASE_URL = isLocal
    ? (rawApiUrl || 'http://localhost:5000')
    : (!isRawApiUrlLocal && rawApiUrl ? rawApiUrl : PROD_API_URL);

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '939305182710-5q2kbf1i1eu5l87jishokehc0em2j576.apps.googleusercontent.com';

export default API_BASE_URL;

export const getImageUrl = (path: string) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;

    // Clean up the path: replace backslashes and remove leading slash
    const cleanPath = path.replace(/\\/g, '/').replace(/^\/+/, '');
    return `${API_BASE_URL}/${cleanPath}`;
};
